import { IntegrationContainer } from '../components/IntegrationContainer';
import { guideUrl } from './consts';
import { Step1 } from './components/Step1';
import { usePersonioConnection } from './hooks';
import { AfterConnection } from './components/AfterConnection';

export const Personio = () => {
  const { handleSelectedCompanyChange, selectedCompany, triggerConnection, isConnected } = usePersonioConnection();

  return (
    <IntegrationContainer setSelectedCompany={handleSelectedCompanyChange} guideUrl={guideUrl}>
      {selectedCompany && (
        <>
          <Step1 triggerConnection={triggerConnection} />
          {isConnected && <AfterConnection isConnected={isConnected} />}
        </>
      )}
    </IntegrationContainer>
  );
};
